import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { leadRepAvailabilityEndpoints } from '@/lib/api/endpoints';
import { leadRepAvailabilityKeys } from '@/lib/queryKeys';

export type LeadRepUnavailableReason = 'PTO' | 'OFF_SHIFT' | 'MANUAL';

export interface LeadRepAvailability {
  userId: string;
  displayName: string;
  firstName: string;
  lastName: string;
  email: string;
  isAvailable: boolean;
  unavailableReason: LeadRepUnavailableReason | null;
  unavailableUntil: string | null;
  updatedAt: string;
}

export function useLeadRepAvailability() {
  return useApiQuery<LeadRepAvailability[]>({
    queryKey: leadRepAvailabilityKeys.list(),
    queryFn: () =>
      apiGet<LeadRepAvailability[]>(operationsClient, leadRepAvailabilityEndpoints.list()),
    showErrorToast: false,
  });
}
